import React from "react";
import {
  Table,
  TableRow,
  TableCell,
  makeStyles,
  Typography,
  TableBody
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { BookingChecks } from "@graphql";
import { Check, InfoOutlined } from "@material-ui/icons";
import WithTooltip from "@components/WithTooltip";

type Props = {
  data: BookingChecks;
  onlyInvalid?: boolean;
};

export const translations = locale.bookingSupportChecks;

export function BookingSupportChecks({ data: response, onlyInvalid }: Props) {
  const classes = useStyles({});
  const { __typename, ...data } = (response || {}) as any;
  const allOk = data && Object.values(data).every((x) => x === null);
  return (
    data && (
      <>
        <Table className={classes.root} size={"small"}>
          <TableBody>
            {Object.keys(data).map((key, index) => {
              return data?.[key] ? (
                <TableRow key={key} className={classes.invalid}>
                  <TableCell component={"th"} style={{ paddingTop: 6 }}>
                    <Typography>{translations[key]}</Typography>
                  </TableCell>
                  <TableCell component={"td"} style={{ paddingTop: 6 }}>
                    <Typography>{data?.[key]}</Typography>
                  </TableCell>
                </TableRow>
              ) : !onlyInvalid ? (
                <TableRow key={key}>
                  <TableCell component={"th"} style={{ paddingTop: 6 }}>
                    <Typography>{translations[key]}</Typography>
                  </TableCell>
                  <TableCell component={"td"} style={{ paddingTop: 6 }}>
                    <Check color={"secondary"} />
                  </TableCell>
                </TableRow>
              ) : null;
            })}
          </TableBody>
        </Table>
        <Table>
          <TableBody>
            {allOk && (
              <TableRow>
                <TableCell component={"th"} style={{ paddingTop: 0, borderBottom: 0 }}>
                  <Typography
                    variant={"h5"}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    {locale.AllChecksPass}
                    <Check color={"secondary"} />
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </>
    )
  );
}

export const BookingSupportChecksInfoTooltip = () => {
  const title = (
    <div>
      <p style={{ padding: "0 16px" }}>
        Kontrollera om alla relevanta uppgifter matchar mellan formulären, tidrapporten,
        bokningsveckan, sammanställningen, Rese- och boendebekräftelserna och
        kundprofilen. Vi kontrollerar:
      </p>
      <ul>
        <li>Kostnadsställe</li>
        <li>Projekt</li>
        <li>Kundnummer</li>
        <li>Avropsnummer</li>
        <li>Kund- och konsultavtal</li>
        <li>Vinst i kronor</li>
        <li>Vinst i %</li>
        <li>Fakturabelopp</li>
        <li>Antal timmar</li>
        <li>Reseersättning</li>
        <li>Konsults egna utgifter</li>
        <li>Verklig kostnad för resa och boende</li>
        <li>Beställares namn</li>
        <li>Gruppfakturering</li>
        <li>Om tidrapport ska bifogas i faktureringen</li>
        <li>Avtalsnummer för kundavtal</li>
      </ul>
    </div>
  );
  return (
    <WithTooltip title={title}>
      <InfoOutlined />
    </WithTooltip>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 16
  },
  invalid: {
    background: "rgb(255, 210, 193)"
  }
}));
